import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import './mend.css';




const Mend = () => {

  const { mendId } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  const [mendData, setMendData] = useState([])

  useEffect(() => {
    const mendData = async () => {
      try{
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/mend/${mendId}`)
        const responseData = await response.json()
        setMendData(responseData.mend);
        setIsLoaded(true)
      } catch(err) {
        console.log(err.message)
      }
    } 
    mendData();
    }, [mendId])
    

  if (!isLoaded) {
    return (
      <main>
        <h1>Article not found</h1>   
        <Link to='/'>Back to main page</Link>
      </main>
    )
  };
    

  return (
    <main className='main-mend-page-container'>
      <div className="mend-page-controller">
        <div className='mend-page-img'>
          <img 
            src={`${process.env.REACT_APP_ASSET_URL}/${mendData.image}`} 
            alt={mendData.name}
          />
          {mendData.name}
        </div>
            
        <div className='mend-page-text-container'>
          <h1>{mendData.title}</h1> 
          <p>{mendData.article}</p>
        </div>
        
      </div>
    </main>
  )   
}
export default Mend;